const TicketRepliesPage = () => import('./index.vue')
const TicketRepliesPageExpert = () => import('./expert_index.vue')
const TicketRepliesPageVipSonko = () => import('./vip_sonko_index.vue')
/*const BlogsFilter = () => import('./_pages/blogs_filter.vue')
const CreateBlogPage = () => import('./_pages/create_blog.vue')*/
import { EditorGuard } from '@/common/guard'

export default [
  {
    path: '/ticketreplies/sonko',
    beforeEnter: EditorGuard,
    component: TicketRepliesPage,
    name: 'TicketRepliesIndex'
  },
  {
    path: '/ticketreplies/expert',
    beforeEnter: EditorGuard,
    component: TicketRepliesPageExpert,
    name: 'TicketRepliesPageExpert'
  },
  {
    path: '/ticketreplies/vip_sonko',
    beforeEnter: EditorGuard,
    component: TicketRepliesPageVipSonko,
    name: 'TicketRepliesPageVipSonko'
  }
  /*{
    path: '/blogs/select/:filter',
    component: BlogsFilter,
    name: 'BlogsFilter'
  },*/
  /*{
    path: '/create/blog',
    component: CreateBlogPage,
    name: 'CreateBlogPage'
  }*/
]
